//-----------------------------------
//DTG
//-----------------------------------
$(function() {

    //Start variables needed:
    var debug;
    var ShirtColor;
    var firstMonoLink;
    var secondMonoLinkImage;
    var soldMonoLink;
    var sendImg;
    var soldImage;
    var extractImage;
    var MonogramText;
    var MonogramText1;
    var threadcolor;
    var threadcolor1;
    var MonogramFont;
    var imagesize;
    var typingTimer;
    var doneTypingInterval = 1200;
    var mono_server;
    var errorDetails;
    var flagStop;
    var bg;
    //End of Variables



    //-----------------------------------
    //Button from the main product page
    //-----------------------------------
    $('#preview-monogram').on('click', function(el) {
        ShirtColor = $('input[name="single-option-selector-1"]:checked').val();


        //old monogramtext check effect $('input[name="properties[Monogram (first | LAST NAME | middle)]"]').val();
        //old threadcolor = $('select[name="properties[Thread Color]"]').find(':selected').attr('data-valcolor');
        MonogramText = $('input#MonogramText').val();
        MonogramText1 = $('input#MonogramText1').val();
        threadcolor = $("#threadcolor option:selected").attr("data-valcolor");
        threadcolor1 = $("#threadcolor1 option:selected").attr("data-valcolor");
        MonogramFont = $('select[name="properties[Font]"]').find(':selected').attr('data-valname');



        ///for debugging 
        //  debug = $('select[name="properties[MonogramFont]"]').find(':selected').attr('data-valname');
        //$("#debug").html(debug);
        ///for debugging

        //Function to display monogram with grey background
        function bg_color_grey() {
            bg = $('.w3-container').css('background-color', '#ffffff');
            bg = $('.w3-row').css('background-color', '#e5e5e5');
            bg = $('#monogramimage').css('background-color', '#e5e5e5');
        }


        //-----------------------------------
        ///Trigger call to monogram's default value
        //-----------------------------------     
        //--------------------------------------------
        //--------Different default display setting    
        //Removed w3-margin  to center the big image
        //--------------------------------------------

        if (MonogramFont.indexOf("DTGGucciMIY") != -1) { // MWL09022022 
            $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field  w3-padding-48 ' style='  object-fit: scale-down'    alt='Monogram here'  src='//cdn.shopify.com/s/files/1/0682/8923/3182/files/DTGGucciMIY.png?v=1680319971'    />");

        } else if (MonogramFont.indexOf("DTGPillow") != -1) { // MWL09022022 
            $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field  w3-padding-48 ' style='  object-fit: scale-down'    alt='Monogram here'  src='//cdn.shopify.com/s/files/1/0682/8923/3182/files/DTGPillowLightPink.png?v=1690899910'    />");

        } else {
            //alert(MonogramFont);
            $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field    w3-padding-48 ' style='  object-fit: fill'    alt='Monogram here'  src='//cdn.shopify.com/s/files/1/0635/8561/files/ABC.png?17829756627205312463'    />");
        }

        //-----------------------------------
        ///End generate monogram default
        //-----------------------------------

        //-----------------------------------
        //---disable the add to cart button and show the pop-up
        //-----------------------------------
        $("#modal").show(500);
        //$("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
        $('.add-to-cart').addClass('disabled').prop('disabled', true);
    });



    //-----------------------------------
    //---------Check all the selections to trigger the Generate monogram
    //------------------------------------Start
    //Detect changes in all the select buttons
    $('select').on('change', function() {
        delayExecute();
    });

    //Detect values input in the textbox
    $('input#MonogramText1').on('keydown', function(event) {
        delayExecute();

    });

    //Detect values input in the textbox
    $('input#MonogramText').on('keydown', function(event) {
        delayExecute();

    });

    //-----------------------------------  
    //Detect keystroke and only execute after the user has finish typing
    //-----------------------------------
    function delayExecute() {
        clearTimeout(typingTimer);
        typingTimer = setTimeout(
            function() {
                GenerateMonogram()
            },
            doneTypingInterval
        );
        return true;
    }
    //-----------------------------------
    //------------------------------------End
    //-----------------------------------



    //-----------------------------------
    //Generate the Customers monogram
    //-----------------------------------  
    function GenerateMonogram() {

        //Get all the value passed
        //MonogramText = $('input#MonogramText').val();
        MonogramText1 = $('input#MonogramText1').val();
        threadcolor = $("#threadcolor option:selected").attr("data-valcolor");
        threadcolor1 = $("#threadcolor1 option:selected").attr("data-valcolor");
        //$('select[name="properties[Thread Color]"]').find(':selected').attr('data-valcolor');
        MonogramFont = $('select[name="properties[Font]"]').find(':selected').attr('data-valname');

        if (MonogramFont.indexOf("DTGPillow") != -1) {
            MonogramText = $('input#MonogramText1').val();

        } else {
            MonogramText = $('input#MonogramText').val();
        }

        //reset the error display
        $("#validatorId").html("");
        flagStop = "";
       // $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
         $('.add-to-cart').addClass('disabled').prop('disabled', true);


        //Validation before creating the monogrammed.
        //-----------------------------------
        if (MonogramText !== "" && threadcolor !== "" && typeof threadcolor !== 'undefined' && MonogramText1 !== "" && threadcolor1 !== "" && typeof threadcolor1 !== 'undefined' && MonogramFont !== "" && typeof MonogramFont !== 'undefined') {



            if (MonogramFont.indexOf("DTG") != -1) { //all BigPrints DTG will go here unless have special info          
                logoColor = "";
                mono_server = "stitchdynamics5";

                //---------Filter of 2 letter styles--------------------------	
                if (MonogramFont.indexOf("DTGGucciMIY") != -1) {
                    threadcolor = "Acfb98a";

                } else if (MonogramFont.slice(-2) == "No") { //added to allow no monogram for 2 to load
                    MonogramText = "**";
                    $("#MonogramText").val('');

                } else if (MonogramFont.indexOf("DTGPillow") != -1) {

                } else {
                    if (MonogramText.length == 2) {
                        errorDetails = "Must have 3 letters for this Style";
                        $("#validatorId").html(" " + errorDetails + "").css("color", "red", "font-style", "italic");
                        flagStop = 1;
                    }
                } //-----------------------------------


            } else if (MonogramFont.indexOf("10-101M") != -1) {
                if (MonogramText.length == 3) {
                    errorDetails = "Must have 2 letters for this Style";
                    $("#validatorId").html(" " + errorDetails + "").css("color", "red", "font-style", "italic");
                    flagStop = 1;
                }

            } else {
                logoColor = "";
                mono_server = "stitchdynamics5";
            }

            //-----------------------------------
            ////---Details sent to lilo's server ^_^ ----------------------------
            //-----------------------------------

            if (flagStop != "1") { //------------------2 Letter

               // $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
                 $("#btn.add-to-cart").addClass('disabled').prop('disabled', true);

                //-------UserAgreement changed 06/26 #JDG            
               // $("#UserAgreement").remove();
                //-------UserAgreement changed 06/26 #JDG            

                //----Set a loader image..
                $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field    w3-padding-48 ' style=' object-fit: cover'  alt='Monogram here'  src='//cdn.shopify.com/s/files/1/0635/8561/files/ajax-loading.gif?638'/>");

                firstMonoLink = "https://" + mono_server + ".com/ecs/api/ecs/7?sku=" + MonogramFont + "&style=" + logoColor + "&pers1=" + encodeURIComponent(MonogramText1) + "&color1=" + threadcolor1 + "&pers2=" + encodeURIComponent(MonogramText) + "&color2=" + threadcolor;

                //extract png file working
                $.get(firstMonoLink, function(data, status) {
                    //alert("Data: " + data + "\nStatus: " + status);
                    sendImg = ("https://" + data);
                    //$("#debug").html(sendImg);
                    //passing of image and Image Display
                    $("#monogramimage").html("<img id='monogramImg'   class='line-item-property__field    w3-padding-48 '  style='  object-fit: fill'   alt='Monogram here'  src='" + sendImg + "'/>");

                    $("#hiddenMonogramImage").html("<input type='hidden'  name='properties[_MonogramImage]'    value='" + sendImg + "' />");
                    $("#monogramImg").on('load', function() {
                        //----Enable the add to cart button once image was successfully loaded
                        //alert("add to cart enabled");

                        //-------UserAgreement changed 06/26 #JDG    
                       // addDivclassUserAgreement();
                       // $('#addtocart').prop('disabled', false).removeClass('disabled');
                         $('#addtocart').removeClass('disabled').prop('disabled', false);
                        //$('#addtocart').prop('disabled', false);
                        //----UserAgreement changed 06/26 #JDG  -----End  

                    });
                });
                /////---------Ending-----------------------  

                // temp disable to check the missing images in the server
                //  $('#addtocart').prop('disabled', false);

            }
            return; //------------------2 Letter             

        } else {
            //---These are blank values.

            if (MonogramText == "") {
                errorDetails = "input your Text";
                $("#MonogramText").attr('disabled', false);
            } else if (threadcolor == "") {
                errorDetails = "select a Threadcolor";
            } else if (MonogramText1 == "") {
                errorDetails = "input your Monogram";
                $("#MonogramText1").attr('disabled', false);
            } else if (threadcolor1 == "") {
                errorDetails = "select a Threadcolor";
            } else {
                errorDetails = "select a Font";
            }
            $("#validatorId").html("Please " + errorDetails + "").css("color", "red", "font-style", "italic");
            $('.add-to-cart').addClass('disabled').prop('disabled', true);
        }

    }

    //----UserAgreement changed 06/26 #JDG  -----Start       
    //-------Function created for adding of divclass to avoid changing the all 100+ html templates 
    function addDivclassUserAgreement() { //replacing the code due to typo error
        $(".w3-containerw3-center").addClass("w3-container w3-center");
        $(".w3-containerw3-center").removeClass("w3-containerw3-center");


        $(".product__payment-container").css("display", "contents");
        $(".product__payment-container").prepend('<div  id="UserAgreement" style="font-size: 90%;display: contents;"><h4><input type="checkbox" id="uaID" name="UserAccept"/> I understand that <b><i>no changes</i></b> can be made to my order once it is submitted. I have reviewed every part of my order: item, color, size, monogram, monogram style, and thread color (if applicable) and confirm that it is entered correctly</h4></div> ');
        $('#uaID').on('change', function() {
            if ((this.checked) && flagStop != "1" && MonogramText != "") {
                $('#btn add-to-cart').prop('disabled', false);
                $('input#MonogramText').on('click', uncheckAll);

            }
            if ((this.checked) && flagStop != "1" && MonogramText1 != "") {
                $('#btn add-to-cart').prop('disabled', false);
                $('input#MonogramText1').on('click', uncheckAll);

            } else {
                $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
            }
        });
        //unchecks agreement once MonogramTextbox is clicked
        function uncheckAll() {
            $("#uaID:checked").prop("checked", false);
            $("#btn add-to-cart").addClass('disabled').attr('disabled', 'disabled');
        }

    }
    //----UserAgreement changed 06/26 #JDG  -----End       
    //-----------------------------------
    //Button close
    //-----------------------------------  

    $("#btnClose").click(function() {
        //Reset Values
         $(".add-to-cart").addClass('disabled').prop('disabled', true);
        //$('input[name="properties[Monogram (first | LAST NAME | middle)]"]').val('');
        $('input#MonogramText').val('');
        $('input#MonogramText1').val('');
        $("#threadcolor option:selected").attr('selected', false).first().attr('selected', true);
        $("#threadcolor1 option:selected").attr('selected', false).first().attr('selected', true);
        //$('select[name="properties[Thread Color]"]').val('');
        $('select[name="properties[Font]"]').attr('selected', false).first().attr('selected', true);
        //-----------end   
        $("#monogramimage").val(''); //clear the monogram
        flagStop = "";
         $("#validatorId").html("");


    });


    //-----------------------------------
    //Add to cart
    //-----------------------------------         
    //Working SENDING SOLD TAG but currently we use
    $('#addtocart').on('click', function(event) {

        // //----UserAgreement changed 06/26 #JDG
        // if (!$('#uaID').is(':checked')) {
        //     event.stopImmediatePropagation();
        //     event.preventDefault();
        //     return false;
        // }
        // //----UserAgreement changed 06/26 #JDG

        window.setTimeout(function() {
            $("#btnClose").click();
           // $("#uaID:checked").prop("checked", false);
        }, 500);

    });

});